
const PromoTermsAndConditions = ({ n }) => {
	const content = () => {
		switch (n) {
			case "welcome-back":
				return `This offer (WELCOME5BACK) can only be used once. This offer cannot be redeemed on medication cost or
				delivery of prescriptions and cannot be used in conjunction with any other offer or other promotion. We
				reserve the right to refuse redemption in the event of unauthorised, ineligible or inappropriate use of
				offer and to modify or cancel the offer at any time.`;
			case "new-inactive":
				return `New users only. This offer (EMPTY5OFF) cannot be redeemed on medication cost or delivery of
					prescriptions and cannot be used in conjunction with any other offer or other promotion. We reserve
					the right to refuse redemption in the event of unauthorised, ineligible or inappropriate use of
					offer and to modify or cancel the offer at any time.`;
			case "health-20-you":
				return `*Terms and Conditions: This code HEALTH20YOU can only be used once. 
					This offer cannot be redeemed on medication cost or delivery of prescriptions and cannot 
					be used in conjunction with any other offer or other promotion. We reserve the right to 
					refuse redemption in the event of unauthorised, ineligible or inappropriate use of offer
					 and to modify or cancel the offer at any time.`;
			case "racv":
				return `*Terms and Conditions: This code RACV20 can only be used once. This offer cannot be redeemed 
					on medication cost or delivery of prescriptions and cannot be used in conjunction with any other offer 
					or other promotion. We reserve the right to refuse redemption in the event of unauthorised, ineligible 
					or inappropriate use of offer and to modify or cancel the offer at any time. `;
			case "get-10-promo":
				return `*Terms and Conditions: This offer is valid until 11:59PM 30 June 2026. This offer can only be used once per user. 
					This offer cannot be redeemed on medication cost or delivery of prescriptions or the Weight Loss Program and cannot 
					be used in conjunction with any other offer or other promotion. We reserve the right to refuse redemption in the event 
					of unauthorised, ineligible or inappropriate use of offer and to modify or cancel the offer at any time.`
			case "promo-empty10off":
				return `This offer (EMPTY10OFF) cannot be redeemed on medication cost or delivery of prescriptions and cannot be used in 
				conjunction with any other offer or other promotion. We reserve the right to refuse redemption in the event of unauthorised, 
				ineligible or inappropriate use of offer and to modify or cancel the offer at any time.`
			default:
				return "";
		}
	};
	return (
		<div className="terms">
			<p>{content()}</p>
		</div>
	);
};

export default PromoTermsAndConditions;
